import lfRequest from '@/service/index'

export function queryStatistical(queryInfo: any) {
  return lfRequest.get<any>({
    url: '/main/fuboStatisticalDept/queryStatistical',
    params: queryInfo
  })
}
